import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'

export const BlogContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1280px;
  margin: auto;
  margin-bottom: 4rem;

  & .infinite-scroll-component {
    overflow-x: hidden;
  }

  ${mediaQueryUp('xl')} {
    padding: 0;
  }
`

export const ArticlesSection = styled.div`
  display: flex;
  width: 100%;
  max-width: 1120px;

  ${mediaQueryUp('m')} {
    margin: 0 5rem;
    width: calc(100% - 10rem);
  }
`
